module.exports = __webpack_public_path__ + "static/media/Klinicq_logo.02fdbd7c.webp";